module.exports = __webpack_public_path__ + "static/media/4.684c9482.jpg";